import React from 'react'

export default React.createContext({
    env: '',
    isMini: false,
    userStatus: false,
    loginOut: ()=>{},
    userInfo: {},
    recommendWebSiteList:[]
})